import { useQuery } from 'react-query';
import { useZoneContext } from '../../contexts/useZoneContext';

export const useGetReportSubTypes = () => {
    const { zoneApiClient } = useZoneContext();
    return useQuery({
        queryKey: ['get-report-sub-types'],
        queryFn: async () => {
            const response = await zoneApiClient.getReportTypes();

            if (response.httpResponse.status === 500) {
                throw new Error('Failed to retrieve expert Report Sub-Types.');
            }

            return (
                response.payload?.sort((a, b) =>
                    (a.displayName ?? '') < (b.displayName ?? '') ? -1 : 1
                ) ?? []
            );
        },
    });
};
